module.exports = function() {
  return new Worker(__webpack_public_path__ + "bff7671b348594f157be.worker.js");
};